module.exports = __webpack_public_path__ + "assets/img/29_199_big.7b1450d1.jpg";